var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"上传图片","visible":_vm.visible,"width":"1000px","modal":false,"append-to-body":"","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.visible=$event}}},[(_vm.visible)?_c('upload-index',{attrs:{"isMore":_vm.isMore,"modelName":_vm.modelName},on:{"getImage":_vm.getImage}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }